'use client';

import React, { useState } from 'react';
import ContactPathways from './ContactPathways';
import DiscoveryCallForm from './DiscoveryCallForm';
import GeneralEnquiryForm from './GeneralEnquiryForm';
import ContactInfo from './ContactInfo';

const ContactInteractive = () => {
  const [selectedPathway, setSelectedPathway] = useState<'discovery' | 'general'>('discovery');

  const handlePathwaySelect = (pathway: 'discovery' | 'general') => {
    setSelectedPathway(pathway);
  };

  return (
    <>
      <ContactPathways 
        onPathwaySelect={handlePathwaySelect}
        selectedPathway={selectedPathway}
      />

      <section className="py-12 lg:py-16 bg-muted/30">
        <div className="container mx-auto px-4">
          <div className="max-w-7xl mx-auto">
            <div className="grid lg:grid-cols-3 gap-8">
              <div className="lg:col-span-2">
                {selectedPathway === 'discovery' && <DiscoveryCallForm />}
                {selectedPathway === 'general' && <GeneralEnquiryForm />}
              </div>

              <div className="lg:col-span-1">
                <ContactInfo />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactInteractive;